import * as React from 'react';
import * as Yup from 'yup';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Formik, FormikActions, FormikProps, Field, FieldProps } from 'formik';
import { mergeFields, processApiError } from 'common/utils/form';

import { Chapter } from 'common/api/models/Chapter';
import { ChapterApi } from 'common/api/resources/ChapterApi';
import { FormInput } from 'common/components/form/FormInput';

interface ChaptersDialogProps {
  chapter?: Chapter;
  onSave: (id: string) => void;
  onCancel: () => void;
}

class ChaptersFormValues {
  name: string = '';
  region: string = '';
  publish: boolean = false;
  wordpressUrl: string = '';
  postId: number = 0;
  buildWordPressTemplate: boolean = false;
}

export class ChaptersDialog extends React.Component<ChaptersDialogProps> {
  validationSchema = Yup.object().shape({
    name: Yup.string().required('Required'),
    region: Yup.string().required('Required'),
  });

  initialValues() {
    let newChapter = mergeFields<Chapter>(new ChaptersFormValues(), this.props.chapter) as ChaptersFormValues;

    if (typeof newChapter.buildWordPressTemplate !== 'boolean') {
      newChapter.buildWordPressTemplate = newChapter.buildWordPressTemplate === '0' ? false : true;
    }

    if (typeof newChapter.publish !== 'boolean') {
      newChapter.publish = newChapter.publish === '0' ? false : true;
    }

    return newChapter;
  }

  handleSubmit = (chapterData: ChaptersFormValues, actions: FormikActions<ChaptersFormValues>) => {
    actions.setSubmitting(true);
    const call =
      this.props.chapter && this.props.chapter.id
        ? ChapterApi.updateChapter(this.props.chapter.id, chapterData)
        : ChapterApi.createChapter(chapterData);
    call.then(
      res => {
        this.props.onSave(this.props.chapter && this.props.chapter.id ? this.props.chapter.id : (res as any).id);
        actions.setSubmitting(false);
        actions.setStatus(undefined);
      },
      err => {
        processApiError<ChaptersDialogProps, ChaptersFormValues>(err, actions);
      }
    );
  };

  handleChange = (val: any, f: any) => {
    if (val === false) {
      f.publish = false;
    }
  };

  render() {
    const title = this.props.chapter && this.props.chapter.id ? 'Edit Chapter' : 'Add Chapter';
    const initialBuildWordPressTemplate = this.props.chapter && this.props.chapter.buildWordPressTemplate;
    return (
      <Modal size="md" isOpen={!!this.props.chapter} toggle={this.props.onCancel} keyboard={true}>
        <Formik
          initialValues={this.initialValues()}
          validationSchema={this.validationSchema}
          onSubmit={this.handleSubmit}
          render={(form: FormikProps<ChaptersFormValues>) => (
            <form onSubmit={form.handleSubmit} noValidate={true}>
              <ModalHeader toggle={this.props.onCancel}>{title}</ModalHeader>
              <ModalBody>
                <div className="row">
                  <div className="col">
                    <FormInput label="Name" name="name" id="name" autoComplete="off" autoFocus={true} />
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <FormInput label="Region" name="region" id="region" autoComplete="off" />
                  </div>
                </div>
                <div className="row">
                  <div className="col">Build Chapter Template</div>
                </div>
                <div className="row">
                  <div className="col">
                    <Field name="buildWordPressTemplate">
                      {({
                        field: { name, value, ...fieldProps },
                        // tslint:disable-next-line: no-shadowed-variable
                        form,
                      }: FieldProps) => (
                        <div className="switch">
                          <input
                            id={name}
                            name={name}
                            className="cmn-toggle cmn-toggle-round-flat"
                            type="checkbox"
                            checked={value === '0' || value === false ? false : true}
                            disabled={!initialBuildWordPressTemplate ? false : true}
                            onChange={this.handleChange(value, form.values)}
                            {...fieldProps}
                          />
                          <label htmlFor={name} />
                        </div>
                      )}
                    </Field>
                  </div>
                </div>

                <div className="row">
                  <div className="col">Publish Chapter Template</div>
                </div>
                <div className="row">
                  <div className="col">
                    <Field name="publish">
                      {({
                        field: { name, value, ...fieldProps },
                        // tslint:disable-next-line: no-shadowed-variable
                        form,
                      }: FieldProps) => (
                        <div className="switch">
                          <input
                            id={name}
                            name={name}
                            className="cmn-toggle cmn-toggle-round-flat"
                            type="checkbox"
                            checked={value === '0' || value === false ? false : true}
                            disabled={!form.values.buildWordPressTemplate ? true : false}
                            {...fieldProps}
                          />
                          <label htmlFor={name} />
                        </div>
                      )}
                    </Field>
                  </div>
                </div>
                {form.status && <div className="alert alert-danger">{form.status}</div>}
              </ModalBody>
              <ModalFooter>
                <div>
                  <Button color="secondary" onClick={this.props.onCancel}>
                    Cancel
                  </Button>{' '}
                  <Button color="primary" type="submit" disabled={form.isSubmitting}>
                    Save
                  </Button>
                </div>
              </ModalFooter>
            </form>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Chapters/ChaptersDialog.tsx